// Lists tailwind styles

export const style: Record<string, string> = {
    h1: "text-5xl font-navine font-semibold tracking-wide mb-28",
    h2: "text-2xl font-navine font-semibold tracking-wider mb-3",
    h3: "text-l md:text-xl font-navine tracking-wider bg-black text-white uppercase flex items-center border-b border-[#878787] h-8 pl-2",
    h3Tall: "text-xl font-navine tracking-wider bg-black text-white uppercase flex items-center border-b border-[#878787] h-16 pl-2",
    h4: "text-s uppercase bg-black text-white flex items-center h-8 pl-2",
    ul: "list-disc mx-6  py-4",
    li: "mb-3 text-justify hyphens-auto text-base",
    section: "mb-12",
    prose: "[&_p]:text-justify [&_p]:text-base [&_p]:hyphens-auto [&_p]:mb-6",
    panel: "flex flex-col flex-1 shadow-[8px_8px_#bfbfbf]",
    panelBorder: "border-solid border-black border-l-2 border-2",
    panelGroup: "md:w-full flex flex-col-reverse md:flex-row gap-6 md:gap-8 px-4",
    panelSingleWrapper: "w-full mb-16",
    titleSquare: "bg-[#ed0000] w-2 h-2 my-auto mr-2",
    contentWrapper: "flex-1",
    image: "flex-1 object-contain",
    textBig: "!text-xl md:!text-2xl",
    infoGroup: "font-navine p-4 flex flex-col gap-2",
    infoLabel: "text-2xl md:text-2xl tracking-wider font-bold w-fit uppercase",
    infoSubLabel: "text-base text-black capitalize"
}